import { type ReactElement } from 'react'

import { WhiteLabel } from '../../../../../../../config/white-label-config'
import { MauLegalInfo } from './components/MauLegalInfo'
import { MauRestrictedJurisdictions } from './components/MauRestrictedJurisdictions'
import { TauroLegalInfo } from './components/TauroLegalInfo'
import { TauroRestrictedJurisdictions } from './components/TauroRestrictedJurisdictions'

export const RESTRICTED_JURISDICTIONS: Partial<Record<WhiteLabel, () => ReactElement>> = {
  tauroMarkets: TauroRestrictedJurisdictions,
  tauroMarketsMauritius: MauRestrictedJurisdictions,
}

export const LEGAL_INFO: Partial<Record<WhiteLabel, () => ReactElement>> = {
  tauroMarkets: TauroLegalInfo,
  tauroMarketsMauritius: MauLegalInfo,
}
